<template>
  <div
    v-if="show"
    class="overlayer"
  >
    <b-spinner
      type="grow"
      variant="success"
      class="centerer"
    />
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
.overlayer {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255,255,255,0.5);
    z-index: 9999;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

.centerer {
    position: absolute;
    top: 50%;
    left: 50%
}
</style>
